const ROUTE_PATHS = {
    SUCCESS_PATH: '/:clientName/whitelist/success',
    REGISTER_PATH: '/:clientName/whitelist/',
    DEFAULT_PATH: 'https://www.asurion.com/',
};

export default ROUTE_PATHS;